import { Params, Path } from 'react-router';
import { MetaDescriptor } from 'react-router';

import type { IChannel } from '@boc/saleor-common/channels/types';

export const genHrefLangs = ({
  location,
  canonicalize,
  url,
  channels,
  defaultLocale,
  defaultChannel,
  supportedLocales,
}: {
  location: Path;
  canonicalize: (path: Path, allowedKeys?: string[] | undefined) => string;
  url: (params: Params) => string;
  channels: IChannel[];
  defaultLocale: string;
  defaultChannel: IChannel;
  supportedLocales: string[];
}) => {
  const hreflangDefault: MetaDescriptor = {
    tagName: 'link',
    rel: 'alternate',
    hrefLang: 'x-default',
    href: canonicalize({
      ...location,
      pathname: url({
        locale: defaultLocale,
        channel: defaultChannel.urlSlug,
      }),
    }),
  };

  const hreflangAlts: MetaDescriptor[] = supportedLocales
    .map((lang) => {
      return channels.map((ch) => {
        // Create hreflang for the default country
        const defaultCountryHreflang = {
          tagName: 'link',
          rel: 'alternate',
          hrefLang: `${lang}-${ch.defaultCountry.toLowerCase()}`,
          href: canonicalize({
            ...location,
            pathname: url({ locale: lang, channel: ch.urlSlug }),
          }),
        };

        // Create hreflangs for supported countries if they exist
        // Filter out the default country to avoid duplicates
        const supportedCountryHreflangs = (ch.supportedCountries || [])
          .filter((country) => country !== ch.defaultCountry)
          .map((country) => ({
            tagName: 'link',
            rel: 'alternate',
            hrefLang: `${lang}-${country.toLowerCase()}`,
            href: canonicalize({
              ...location,
              pathname: url({ locale: lang, channel: ch.urlSlug }),
            }),
          }));

        return [defaultCountryHreflang, ...supportedCountryHreflangs];
      });
    })
    .flat()
    .flat();

  return [hreflangDefault, ...hreflangAlts];
};

export { factoryLoader } from './robots';
